import { defineMessage, useIntl } from 'react-intl';
import { Basket32 } from '@packages/themes/icons';
import useSWR from 'swr';
import { useSession, logger } from '@packages/utilities';
import { Slot } from './Slot';
import { useIsCheckoutRoute } from './useIsCheckoutRoute';

const title = defineMessage({
  id: 'slot.basket.displaytext',
  defaultMessage: 'Warenkorb',
});

// TODO(api-layer): delete unnecessary fetcher and use generated types after resolver are available in api-layer
const fetcher = ([url, token]: Array<string>): Promise<{
  size: number;
  subTotal: { currencyCode: string; value: number };
}> =>
  fetch(url, { headers: { 'x-ec-token': token } }).then((res) => {
    if (!res.ok) {
      throw new Error(`Get count from basket error: Status ${res.status}: ${res.statusText}`);
    }
    return res.json();
  });

/** Cart slot */
export const BasketSlot = () => {
  const { formatMessage } = useIntl();
  const isAccountUrl = useIsCheckoutRoute();

  const { jwtToken } = useSession();
  const { data, error } = useSWR(
    jwtToken && !isAccountUrl ? ['/api/checkout/v1/abstract', jwtToken] : null,
    fetcher,
  );

  if (error) {
    // TODO(error-handling): add service (does not make sense to log into browser console)
    logger.error(error);
  }

  if (isAccountUrl) return null;

  return (
    <Slot
      useRouterLink={false}
      icon={<Basket32 />}
      linkAriaLabel={formatMessage(title)}
      href="/warenkorb"
      badgeCount={data ? data.size : 0}
      title={formatMessage(title)}
    />
  );
};
